export default __webpack_public_path__ + "static/media/logo-ir.729d8884.svg";